import { create } from 'zustand'

export interface IEndGameStore {
  refNo: string
  /** false = 後端尚未結算（PlaceOrderV2 balance 回 -1 的延遲結算單），動畫播完要 call EndGame */
  isSettled: boolean
}

export const useEndGameStore = create<IEndGameStore>(() => ({
  refNo: '',
  isSettled: true,
}))
